module.exports = __webpack_public_path__ + "media/images/official/plancheck_icon_10_2-ec2c1f64614f05a407e4223124b8d58b.svg";